// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1IrOp","imageUploader":"EGiftCard_imageUploader__3_P64"};